var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#CBC8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2198 16.6958C16.5205 16.6958 18.3857 14.8306 18.3857 12.5298C18.3857 10.2291 16.5205 8.36392 14.2198 8.36392C11.919 8.36392 10.0538 10.2291 10.0538 12.5298C10.0538 14.8306 11.919 16.6958 14.2198 16.6958Z",
    fill: "#CBC8FF",
    stroke: "#563AFF",
    strokeWidth: 0.997492,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30969 19.9001C8.94987 18.9158 9.82576 18.107 10.8578 17.5471C11.8899 16.9871 13.0455 16.6939 14.2197 16.6939C15.3939 16.6939 16.5495 16.9871 17.5815 17.5471C18.6136 18.107 19.4895 18.9158 20.1297 19.9001",
    stroke: "#563AFF",
    strokeWidth: 0.997492,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.414b107cf0891722422e5604b6d3548b.svg";
export { ForwardRef as ReactComponent };